import React from 'react';
import { connect } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import ListPublicaciones from './Components/ListPublicaciones';
import PublicacionNew from './Components/ABM/PublicacionNew';
import PublicacionEdit from './Components/ABM/PublicacionEdit';
import CreacionMasivaPublicaciones from './Components/Excel/CreacionMasivaPublicaciones';
import CreacionMasivaWizard from './Components/Excel/CreacionMasivaWizard';
import ActualizacionMasivaPublicaciones from './Components/Excel/ActualizacionMasivaPublicaciones';
import ActualizacionMasivaWizard from './Components/Excel/ActualizacionMasivaWizard';
import FechasCreacionPublicaciones from './Components/FechasCreacionPublicaciones';
import {
    canShowCreacionMasivaWizard,
    canShowActualizacionMasivaWizard
} from '../../utilities/masivaWizardAccess';

class AdmPublicaciones extends React.Component {
    render () {
        const { userType } = this.props;
        const showCreacionMasivaWizard = canShowCreacionMasivaWizard(userType);
        const showActualizacionMasivaWizard = canShowActualizacionMasivaWizard(userType);
        const isAdmin = userType?.isCategory || userType?.isAdminMod;

        return (
            <div>
                <Routes>
                    <Route path="" element={<ListPublicaciones/>}/>
                    <Route path="Nueva/:idSeller" element={<PublicacionNew/>}/>
                    <Route path="Editar/:idSeller/:id" element={<PublicacionEdit/>}/>
                    <Route
                        path="CreacionMasiva"
                        element={
                            showCreacionMasivaWizard
                                ? <CreacionMasivaWizard/>
                                : <CreacionMasivaPublicaciones/>
                        }
                    />
                    <Route
                        path="CreacionMasivaExcel"
                        element={
                            showCreacionMasivaWizard
                                ? <CreacionMasivaPublicaciones/>
                                : <Navigate to="/Publicaciones/CreacionMasiva" replace />
                        }
                    />
                    <Route path="CreacionMasivaWizard" element={<Navigate to="/Publicaciones/CreacionMasiva" replace />} />
                    <Route
                        path="ActualizacionMasiva"
                        element={
                            showActualizacionMasivaWizard
                                ? <ActualizacionMasivaWizard/>
                                : <ActualizacionMasivaPublicaciones/>
                        }
                    />
                    <Route
                        path="ActualizacionMasivaExcel"
                        element={
                            showActualizacionMasivaWizard
                                ? <ActualizacionMasivaPublicaciones/>
                                : <Navigate to="/Publicaciones/ActualizacionMasiva" replace />
                        }
                    />
                    <Route path="ActualizacionMasivaWizard" element={<Navigate to="/Publicaciones/ActualizacionMasiva" replace />} />
                    <Route
                        path="FechasCreacion"
                        element={
                            isAdmin
                                ? <FechasCreacionPublicaciones />
                                : <Navigate to="/Publicaciones" replace />
                        }
                    />
                </Routes>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    userType: state.general.userType
});

export default connect(mapStateToProps)(AdmPublicaciones);
